import { Row } from "./Row";
interface IProsp {
  isShow: boolean;
  onToggle: () => void;
}

export const ContactingUsWithQuestions = ({ onToggle, isShow }: IProsp) => {
  return (
    <Row
      title=" Contacting Us With Questions, Concerns, or Privacy Complaints"
      onToggle={onToggle}
      isShow={isShow}
    >
      <div>
        Please direct all requests for assistance, questions, or complaints
        about our privacy practices to our privacy team by email, postal mail,
        or phone at the following contact information:
        <div className="mt-4">
          Attention: Privacy Team <br />
          Email: support@medcursor.com <br />
          Postal Address: 848 N. Rainbow Blvd. Ste 9027 Las Vegas, NV 89107{" "}
          <br />
          Tel-Number: 9497775689
        </div>
        <div className="mt-4">
          If you have any concern or complaint about Medcursor’s privacy policies
          or practices, please provide information relevant to your complaint.
          Our privacy team will evaluate your concern or complaint based on the
          information you provide and send you a response. We may need to ask
          you for additional information to evaluate your concern or complaint.
          We will promptly investigate and respond to your communications about
          a complaint. You may have other rights under law and the right to
          contact the privacy regulator in your local jurisdiction about your
          concern or complaint.
        </div>
      </div>
    </Row>
  );
};
